var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "body" }, [
    _c("div", { staticClass: "status-details" }, [
      _c("div", { staticClass: "description" }, [
        _vm._v(
          "\n      Nessa etapa os antecedentes do profissional serão/estão sendo\n      verificados.\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "events" }, [
        _c(
          "ul",
          _vm._l(_vm.events, function(event) {
            return _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm._f("getStatusName")(_vm.eventName(event.event_type))
                  )
                )
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.formattedDate(event.created_at)))])
            ])
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "actions" },
      [
        _vm.isFailedBackgroundCheckRequest
          ? _c(
              "v-btn",
              {
                attrs: {
                  color: "primary",
                  small: "",
                  loading: _vm.requestBackgroundCheckPreloader
                },
                on: { click: _vm.requestProfessionalBackgroundCheck }
              },
              [_vm._v("\n      Solicitar verificação dos antecedentes\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isWaitingBackgroundCheck && _vm.isProcessingDocuments
          ? _c(
              "v-btn",
              {
                attrs: {
                  color: "primary",
                  small: "",
                  loading: _vm.checkBackgroundCheckOnCAFPreloader
                },
                on: { click: _vm.checkDocOnDataAssuranceService }
              },
              [_vm._v("\n      Atualizar status dos antecedentes no CAF\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isWaitingBackgroundCheck && !_vm.isProcessingDocuments
          ? _c(
              "v-btn",
              {
                attrs: {
                  color: "success",
                  small: "",
                  loading: _vm.approvedBackgroundCheckPreloader
                },
                on: { click: _vm.approveBackgroundCheck }
              },
              [_vm._v("\n      Aprovar os antecedentes\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isBackgroundCheckSuccess
          ? _c(
              "v-btn",
              {
                attrs: {
                  color: "primary",
                  small: "",
                  loading: _vm.createProfessionalPGAOnGatewayPreloader
                },
                on: { click: _vm.createProfessionalPGAOnGateway }
              },
              [
                _vm._v(
                  "\n      Criar conta do profissional no meio de pagamento\n    "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isBackgroundCheckFailed
          ? _c(
              "div",
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "error",
                      small: "",
                      loading: _vm.denyAccessPreloader,
                      disabled:
                        _vm.requestBackgroundCheckPreloader ||
                        _vm.approvedBackgroundCheckPreloader
                    },
                    on: { click: _vm.denyAccess }
                  },
                  [_vm._v("\n        Negar o acesso\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "success",
                      small: "",
                      loading: _vm.approvedBackgroundCheckPreloader,
                      disabled:
                        _vm.requestBackgroundCheckPreloader ||
                        _vm.denyAccessPreloader
                    },
                    on: { click: _vm.approveBackgroundCheck }
                  },
                  [_vm._v("\n        Aprovar os antecedentes\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "primary",
                      small: "",
                      loading: _vm.requestBackgroundCheckPreloader,
                      disabled:
                        _vm.denyAccessPreloader ||
                        _vm.approvedBackgroundCheckPreloader
                    },
                    on: { click: _vm.requestProfessionalBackgroundCheck }
                  },
                  [
                    _vm._v(
                      "\n        Solicitar nova verificação dos antecedentes\n      "
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-772e853e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772e853e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Professionals/Edit/Tabs/Register/Steps/BackgroundCheckValidation.vue
// module id = null
// module chunks = 